export type AttendanceContext = Record<string, unknown>

export type AttendanceDisambiguationPick = {
  personId?: string
  userId?: number
  studentId?: string | number
  name?: string
  grade?: string
  section?: string
  type?: string
  classId?: string | number
  className?: string
  /** Set instead of `classId` when the pick was a SUBJECT. The two id spaces overlap, so reusing
   *  `classId` would pin the answer to whichever class happens to share that number. */
  subjectId?: string | number
}

export type AttendanceChatRequestOptions = {
  attendanceContext?: AttendanceContext | null
  disambiguationPick?: AttendanceDisambiguationPick
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return value != null && typeof value === 'object' && !Array.isArray(value)
}

export function extractAttendanceContext(response: unknown): AttendanceContext | null {
  const r = response as Record<string, unknown>
  const candidates = [
    (r?.result as Record<string, unknown> | undefined)?.attendanceContext,
    r?.attendanceContext,
    (r?.data as Record<string, unknown> | undefined)?.attendanceContext,
    (
      (r?.result as Record<string, unknown> | undefined)?.data as
        | Record<string, unknown>
        | undefined
    )?.attendanceContext,
  ]

  for (const candidate of candidates) {
    if (isRecord(candidate)) return candidate
  }

  return null
}
